$(document).ready(function () {
    $(".ir-updates-for").slick({
        slidesToShow: 2.4,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        autoplay: false,
        variableWidth: true,
        swipeToSlide: true,
        responsive: [{
            breakpoint: 1200,
            settings: {
                    slidesToShow: 3.2,
                    slidesToScroll: 1,
                },
            },
            {
            breakpoint: 768,
            settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                },
            },
            
        ],
    });
    $(".ir-updates .prev-btn").click(function () {
        $(".ir-updates-for").slick("slickPrev");
    });

    $(".ir-updates .next-btn").click(function () {
        $(".ir-updates-for").slick("slickNext");
    });
    $(".ir-updates .prev-btn").addClass("ctrl-disabled");
    $(".ir-updates-for").on("afterChange", function () {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".prev-btn").addClass("ctrl-disabled");
        } else {
            $(".prev-btn").removeClass("ctrl-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".next-btn").addClass("ctrl-disabled");
        } else {
            $(".next-btn").removeClass("ctrl-disabled");
        }
    });
});

// 
$(document).ready(function () {
    $(".ir-updates-variant-for").slick({
        slidesToShow: 2.4,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        autoplay: false,
        variableWidth: true,
        swipeToSlide: true,
        responsive: [{
            breakpoint: 1200,
            settings: {
                    slidesToShow: 3.2,
                    slidesToScroll: 1,
                },
            },
            {
            breakpoint: 768,
            settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                },
            },
            
        ],
    });
    $(".ir-updates-variant .prev-btn").click(function () {
        $(".ir-updates-variant-for").slick("slickPrev");
    });

    $(".ir-updates-variant .next-btn").click(function () {
        $(".ir-updates-variant-for").slick("slickNext");
    });
    $(".ir-updates-variant .prev-btn").addClass("ctrl-disabled");
    $(".ir-updates-variant-for").on("afterChange", function () {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".prev-btn").addClass("ctrl-disabled");
        } else {
            $(".prev-btn").removeClass("ctrl-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".next-btn").addClass("ctrl-disabled");
        } else {
            $(".next-btn").removeClass("ctrl-disabled");
        }
    });
});